import axios from 'axios'
import '@/services/axiosConfig'
import { reasonForGatewayMessage, rememberLogoutReason } from './logoutReason'

export type SessionVerdict = 'valid' | 'invalid' | 'unreachable'

const inFlight = new Map<string, Promise<SessionVerdict>>()

export const verifyStoredSession = (token: string): Promise<SessionVerdict> => {
  const pending = inFlight.get(token)
  if (pending) return pending

  const request = probe(token).finally(() => inFlight.delete(token))
  inFlight.set(token, request)
  return request
}

const probe = async (token: string): Promise<SessionVerdict> => {
  try {
    await axios.get('/api/user/sites', {
      headers: { Authorization: `Bearer ${token}` },
      skipAuthRedirect: true,
      timeout: 10_000,
    })
    return 'valid'
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 401) {
      // A newer token was stored while this one was checked: a password change renewed it, or another tab stored it.
      const stored = localStorage.getItem('authToken')
      if (stored && stored !== token) return verifyStoredSession(stored)
      rememberLogoutReason(reasonForGatewayMessage(err.response.data?.message))
      return 'invalid'
    }
    return 'unreachable'
  }
}
